import CryptoJS from "crypto-js";

// Encryption of payload
const generateRandomKey = () => {
  const keyLength = 128;
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomKey = "";
  for (let i = 0; i < keyLength; i++) {
    randomKey += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return randomKey;
};

export const encryptValues = (values) => {
  if (values || values === false) {
    const valuesString = JSON.stringify(values);
    const encryptionKey = generateRandomKey();
    const encryptedValues = CryptoJS.AES.encrypt(valuesString, encryptionKey).toString();

    return { security_text: encryptionKey + encryptedValues };
  }
};

export const encryptId = (values) => {
  const valuesString = JSON.stringify(values);
  const encryptionKey = generateRandomKey();
  const encryptedValues = CryptoJS.AES.encrypt(valuesString, encryptionKey).toString();
  const encodedEncryptedValues = encodeURIComponent(encryptedValues);
  return encryptionKey + encodedEncryptedValues;
};

//Decryption of payload
export const decryptData = (encryptedData) => {
  let secretKey = encryptedData.slice(0, 128);
  let encryptedMessage = encryptedData.substring(128);
  const decryptedData = CryptoJS.AES.decrypt(encryptedMessage, secretKey).toString(
    CryptoJS.enc.Utf8
  );
  return JSON.parse(decryptedData);
};
